<footer class="footer">
  <div class="container-fluid">
    <p><b>© Cuality Company Corporation</b></p>
    <p class="split">&nbsp;</p>
  </div>
</footer>
